import React, { Component } from 'react'

class EQuoteSearchFiltersFullFormCruiseType extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const {
      voyageType,
      currentBrand,
      voyageTypes,
      handleSelectVoyageType
    } = this.props

    return (
      <div className="equote__search-filters-form-field-input u-custom-select">
        <select
          name="cruiseType"
          onChange={e => handleSelectVoyageType(e.target.value)}
          tabIndex={0}
          value={voyageType || 'O,V'}
          aria-labelledby="curiseTypeToggleLabel"
        >
          {voyageTypes &&
            voyageTypes.map(type => (
              <option
                key={type.value}
                value={type.value}
                disabled={!type.brands.includes(currentBrand)}
              >
                {type.label}
              </option>
            ))}
        </select>
        <span className="u-custom-select__arrow" />
      </div>
    )
  }
}

export default EQuoteSearchFiltersFullFormCruiseType
